import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../config';

export function useRestoreCustomerUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      return await api.post(`/api/v1/admin/customer-users/${userId}/restore`, {});
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customerUsers'] });
      queryClient.invalidateQueries({ queryKey: ['customerUsers', 'trash'] });
    },
  });
}

export function usePermanentlyDeleteCustomerUser() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (userId: string) => {
      return await api.delete(`/api/v1/admin/customer-users/${userId}/permanent`);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['customerUsers', 'trash'] });
    },
  });
}
